import React from "react";
import "./Shop.css";
import { useNavigate } from "react-router-dom";

const produits = [
   {
    id: 1,
    nom: "iPhone 17",
    prix: "750 000 FCFA",
    image: "/images/iphone17.png",
    description: "Le nouvel iPhone 17 avec puce A19 et design amélioré.",
  },
  {
    id: 2,
    nom: "iPhone 17 Pro",
    prix: "900 000 FCFA",
    image: "/images/iphone17pro.png",
    description: "L’iPhone 17 Pro avec puce A19 Pro et caméra triple révolutionnaire.",
  },
  {
    id: 3,
    nom: "iPhone 17 Pro Max",
    prix: "1 050 000 FCFA",
    image: "/images/iphone17promax.png",
    description: "L’iPhone 17 Pro Max, l’expérience ultime avec écran 120Hz et batterie longue durée.",
  },
  {
    id: 4,
    nom: "AirPods Max",
    prix: "25 000 CFA",
    image: "/images/airpods.png",
    description: "Un son haute fidélité et une réduction de bruit incroyable.",
  },
  {
    id: 5,
    nom: "Apple Watch Series 11",
    prix: "60 000 CFA",
    image: "/images/applewatch11.png",
    description: "Suivez votre santé et vos performances sportives avec élégance.",
  },
 
];

const Shop = () => {
  const navigate = useNavigate();

  const handleInfo = (produit) => {
    alert(`ℹ️ ${produit.nom}\n\n${produit.description}`);
  };

  const handleCommander = (produit) => {
    navigate("/commande", { state: { produit } });
  };

  return (
    <div className="shop-container">
      <h1>🛍️ Nos Produits</h1>
      <div className="produits-grid">
        {produits.map((produit) => (
          <div key={produit.id} className="produit-card">
            <img src={produit.image} alt={produit.nom} />
            <h3>{produit.nom}</h3>
            <p className="prix">{produit.prix}</p>
            <div className="boutons">
              <button className="btn-info" onClick={() => handleInfo(produit)}>
                <i className="fa-solid fa-circle-info"></i> Infos
              </button>
              <button className="btn-panier" onClick={() => handleCommander(produit)}>
                <i className="fa-solid fa-bag-shopping"></i> Commander
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Shop;
